export default __webpack_public_path__ + "static/info_1-e3890d9d76540dd8dad2f7e0bc33e52d.png";